/* ===========================================================================
   LMP Shipping, quote card. Paste a link / several links / invoice text →
   CBM × $300 headline + the two "Not included" lines. Scraping stays server-side.
   =========================================================================== */
(function () {
  'use strict';

  var ENDPOINT =
    (window.LMP_QUOTE_ENDPOINT && String(window.LMP_QUOTE_ENDPOINT).trim()) ||
    'http://localhost:8787/api/quote';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Email captured for lead collection (logged-in customer or typed in), shared with logging.
  var quoteEmail = '';
  // Log every estimate request to the ops app (App Proxy) so staff can review them.
  function logQuote(input, extra) {
    try {
      fetch('/apps/lmp/quote-request', {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ input: input || '', email: quoteEmail }, extra || {})),
      }).catch(function () {});
    } catch (e) {}
  }
  function firstUrl(text) { var m = (text || '').match(/https?:\/\/[^\s"']+/i); return m ? m[0] : null; }
  // Heuristic: a category/collection/search page (not a single product), we can't read a size from it.
  function looksLikeCollection(url) {
    try {
      var u = new URL(url), p = u.pathname.toLowerCase();
      var isProduct = /\/(p|dp|ip|pdp|pd|product|products|prod|item)(\/|-|$)/.test(p) || /\/[a-z0-9-]+-\d{5,}(\/|$)/.test(p);
      if (isProduct) return false;
      return /\/(collections|collection|category|categories|c|browse|shop|sb|se|sale|clearance|deals|search|b|l|pl|list|results|department)(\/|$)/.test(p) || /[?&](q|query|search|keyword)=/.test(u.search);
    } catch (e) { return false; }
  }

  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
  function pair(nis, usd) { return '₪' + fmt(nis) + ' · $' + fmt(usd); }

  function countUp(el, nis, usd) {
    if (REDUCED) { el.textContent = pair(nis, usd); return; }
    var dur = 750, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = pair(nis * e, usd * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCard(card) {
    var form = card.querySelector('[data-lmp-quote-form]');
    if (!form) return;
    var pasteEl = card.querySelector('[data-lmp-paste]');
    var emailEl = card.querySelector('[data-lmp-email]');
    var zoneEl = card.querySelector('[data-lmp-zone]');
    var submitBtn = card.querySelector('[data-lmp-submit]');
    var msgEl = card.querySelector('[data-lmp-msg]');
    var manual = card.querySelector('[data-lmp-manual]');
    var result = card.querySelector('[data-lmp-result]');
    var headlineEl = card.querySelector('[data-lmp-headline]');
    var cbmEl = card.querySelector('[data-lmp-cbm]');
    var excludedEl = card.querySelector('[data-lmp-excluded]');
    var disclaimerEl = card.querySelector('[data-lmp-disclaimer]');
    var productEl = card.querySelector('[data-lmp-product]');

    function showMsg(t, on) { if (msgEl) { msgEl.textContent = t || ''; msgEl.hidden = !on; } }
    function setLoading(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      submitBtn.dataset.label = submitBtn.dataset.label || submitBtn.textContent;
      if (on) {
        // A little ship sails left→right across the button to signal "calculating".
        submitBtn.innerHTML =
          '<span class="lmp-ship-load" role="status" aria-label="Calculating your estimate">' +
          '<span class="lmp-ship-load-boat">🚢</span></span>';
      } else {
        submitBtn.textContent = submitBtn.dataset.label;
      }
    }

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function fmtDims(l, w, h) {
      if (l == null || w == null || h == null) return null;
      function r(x) { return Math.round(x * 10) / 10; }
      return r(l) + ' × ' + r(w) + ' × ' + r(h) + ' cm';
    }
    function hideProducts() { if (productEl) { productEl.hidden = true; productEl.innerHTML = ''; } }
    // Show the scraped image + what we read, so the customer confirms it's the same item.
    function renderProducts(items) {
      if (!productEl) return;
      var list = (items || []).filter(function (it) { return it && (it.imageUrl || it.title || it.itemLengthCm != null || it.itemValueUSD != null); });
      if (!list.length) { hideProducts(); return; }
      productEl.innerHTML = list.map(function (it) {
        var img = it.imageUrl
          ? '<img class="lmp-product-img" src="' + esc(it.imageUrl) + '" alt="' + esc(it.title || 'Product') + '" loading="lazy" referrerpolicy="no-referrer">'
          : '<div class="lmp-product-img lmp-product-noimg">📦</div>';
        var meta = [];
        if (it.itemValueUSD != null) meta.push('<span><b>Value:</b> $' + Math.round(it.itemValueUSD).toLocaleString('en-US') + '</span>');
        var itemDims = fmtDims(it.itemLengthCm, it.itemWidthCm, it.itemHeightCm);
        if (itemDims) meta.push('<span><b>Item size:</b> ' + itemDims + '</span>');
        var boxDims = fmtDims(it.lengthCm, it.widthCm, it.heightCm);
        if (boxDims) meta.push('<span><b>' + (it.boxEstimated ? 'Est. box size' : 'Box size') + ':</b> ' + boxDims + '</span>');
        var notes = '';
        if (it.boxEstimated && boxDims) notes += '<div class="lmp-product-note">Box size estimated from the item dimensions.</div>';
        if (it.needsManualDims) notes += '<div class="lmp-product-note">We couldn’t read the size, please enter it below.</div>';
        return '<div class="lmp-product-card"><div class="lmp-product-media">' + img + '</div>' +
          '<div class="lmp-product-info">' + (it.title ? '<div class="lmp-product-title">' + esc(it.title) + '</div>' : '') +
          '<div class="lmp-product-meta">' + meta.join('') + '</div>' + notes + '</div></div>';
      }).join('');
      productEl.hidden = false;
    }

    function manualValues() {
      var v = {};
      manual.querySelectorAll('input').forEach(function (f) {
        if (f.value !== '') v[f.name] = f.value;
      });
      return v;
    }

    function render(quote) {
      countUp(headlineEl, quote.headline.nis, quote.headline.usd);
      if (cbmEl) cbmEl.textContent = quote.cbm + ' m³ (CBM)';
      excludedEl.innerHTML = '';
      quote.excluded.forEach(function (line) {
        var row = document.createElement('div');
        row.className = 'lmp-excl-row';
        var amount = line.usd != null ? '<b>₪' + fmt(line.nis) + ' · $' + fmt(line.usd) + '</b>' : '<b>added later</b>';
        row.innerHTML =
          '<span class="lmp-excl-label">' + line.label +
          ' <em class="lmp-excl-tag">' + (line.note || 'Not included') + '</em></span>' + amount;
        excludedEl.appendChild(row);
      });
      if (disclaimerEl) disclaimerEl.textContent = quote.disclaimer;
      result.classList.add('show');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var paste = (pasteEl && pasteEl.value.trim()) || '';
      quoteEmail = (emailEl && emailEl.value.trim()) || '';
      var body = manualValues();
      if (zoneEl) body.deliveryZone = zoneEl.value;
      if (paste) body.text = paste;

      var hasManual = body.lengthCm != null && body.widthCm != null && body.heightCm != null;
      if (!paste && !hasManual) {
        showMsg('Paste a product link (or several), or fill in the dimensions below.', true);
        manual.classList.add('show');
        return;
      }

      // If the only thing pasted is a category/collection page, we can't read a product size.
      var url0 = firstUrl(paste);
      if (url0 && !hasManual && paste.trim().split(/\s+/).length === 1 && looksLikeCollection(url0)) {
        showMsg('That link looks like a category or collection page, not a single product. Please paste the link to a specific product so we can read its size, or enter the dimensions below.', true);
        manual.classList.add('show');
        logQuote(paste, { parsedOk: false, failReason: 'collection/category page' });
        return;
      }

      setLoading(true); showMsg('', false);
      var ac = ('AbortController' in window) ? new AbortController() : null;
      var to = setTimeout(function () { if (ac) ac.abort(); }, 40000);
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: ac ? ac.signal : undefined,
      })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }); })
        .then(function (res) {
          var j = res.j;
          if (res.status >= 400 || j.error) {
            showMsg(j.error || 'Something went wrong. Try again.', true);
            if (/dimension|valid product URL/i.test(j.error || '')) manual.classList.add('show');
            hideProducts();
            logQuote(paste, { parsedOk: false, failReason: j.error || ('upstream ' + res.status) });
            return;
          }
          if (j.needsManualDims) {
            manual.classList.add('show');
            var first = (j.items && j.items[0]) || {};
            if (first.title) prefill('itemValueUSD', first.itemValueUSD);
            var warn = (j.warnings && j.warnings[0]) || 'Add the missing dimensions and calculate again.';
            showMsg((first.title ? 'Found: ' + first.title + '. ' : '') + warn, true);
            renderProducts(j.items);
            logQuote(paste, { parsedOk: false, failReason: 'needs manual dimensions', raw: j });
            return;
          }
          if (j.quote) {
            showMsg('', false); renderProducts(j.items); render(j.quote);
            logQuote(paste, {
              parsedOk: true,
              estimateUsd: (j.quote.totalUsd != null ? j.quote.totalUsd : (j.quote.landedUsd != null ? j.quote.landedUsd : j.quote.seaFreightUsd)),
              cbm: j.quote.cbm, itemValueUsd: j.quote.itemValueUSD, raw: j.quote,
            });
          }
        })
        .catch(function (err) {
          var aborted = err && err.name === 'AbortError';
          showMsg(aborted
            ? 'This is taking too long, the store may be blocking automated reads. Please enter the size below and we’ll estimate it.'
            : 'Could not reach the estimate service. Check your connection and try again.', true);
          if (aborted) manual.classList.add('show');
          logQuote(paste, { parsedOk: false, failReason: aborted ? 'timeout' : 'network error' });
        })
        .then(function () { clearTimeout(to); setLoading(false); });
    });

    function prefill(name, val) {
      if (val == null) return;
      var f = manual.querySelector('[name="' + name + '"]');
      if (f && f.value === '') f.value = val;
    }
  }

  /* ---- Local pickup request form ---------------------------------------- */
  var PICKUP_ENDPOINT = ENDPOINT.replace(/\/api\/quote\b/, '/api/pickup');

  function initPickup(form) {
    var submit = form.querySelector('[data-lmp-pickup-submit]');
    var msg = form.querySelector('[data-lmp-pickup-msg]');
    var fileInput = form.querySelector('input[type="file"]');

    function showMsg(t, ok) {
      if (!msg) return;
      msg.textContent = t;
      msg.hidden = false;
      msg.style.color = ok ? 'var(--teal)' : 'var(--clay)';
    }
    function readImage() {
      return new Promise(function (resolve) {
        var f = fileInput && fileInput.files && fileInput.files[0];
        if (!f) return resolve({ hasImage: false });
        if (f.size > 1.5 * 1024 * 1024) return resolve({ hasImage: true }); // too big to inline; we'll request it later
        var fr = new FileReader();
        fr.onload = function () { resolve({ hasImage: true, imageUrl: String(fr.result) }); };
        fr.onerror = function () { resolve({ hasImage: true }); };
        fr.readAsDataURL(f);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var body = {};
      form.querySelectorAll('input, textarea').forEach(function (f) {
        if (f.type === 'file') return;
        if (f.value !== '') body[f.name] = f.value;
      });
      if (submit) { submit.disabled = true; submit.dataset.label = submit.dataset.label || submit.textContent; submit.textContent = 'Sending…'; }
      readImage()
        .then(function (img) {
          Object.assign(body, img);
          return fetch(PICKUP_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }); })
        .then(function (res) {
          if (res.status >= 400) { showMsg((res.j.errors && res.j.errors.join(' · ')) || res.j.error || res.j.message || 'Please check the form.', false); return; }
          showMsg(res.j.message || 'Thanks, we received your pickup request.', true);
          form.reset();
        })
        .catch(function () { showMsg('Could not send your request. Please try again.', false); })
        .then(function () { if (submit) { submit.disabled = false; submit.textContent = submit.dataset.label; } });
    });
  }

  /* ---- Upload-a-cart card: screenshot / JPEG / PDF → sent to the team -------
     Reads the file, sends it (base64) to the ops App Proxy so staff can size the
     shipment and email the estimate. Swaps to auto-calc once the vision API is
     wired to this same endpoint. ------------------------------------------- */
  function initUploadCard(card) {
    var form = card.querySelector('[data-lmp-upload-form]');
    if (!form) return;
    var input = card.querySelector('[data-lmp-upload-input]');
    var drop = card.querySelector('[data-lmp-upload-drop]');
    var nameEl = card.querySelector('[data-lmp-upload-name]');
    var emailEl = card.querySelector('[data-lmp-upload-email]');
    var submit = card.querySelector('[data-lmp-upload-submit]');
    var msg = card.querySelector('[data-lmp-upload-msg]');
    var file = null;

    function showMsg(t, ok) { if (!msg) return; msg.textContent = t; msg.hidden = false; msg.style.color = ok ? 'var(--teal)' : 'var(--clay)'; }
    function setFile(f) { file = f; if (f && nameEl) { nameEl.textContent = 'Selected: ' + f.name; nameEl.hidden = false; } }
    if (input) input.addEventListener('change', function () { if (input.files && input.files[0]) setFile(input.files[0]); });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
      drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) setFile(f); });
    }
    function readFile(f) {
      return new Promise(function (resolve) {
        if (!f) return resolve(null);
        if (f.size > 8 * 1024 * 1024) return resolve({ tooBig: true });
        var fr = new FileReader();
        fr.onload = function () { resolve({ name: f.name, type: f.type, dataUrl: String(fr.result) }); };
        fr.onerror = function () { resolve(null); };
        fr.readAsDataURL(f);
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl && emailEl.value || '').trim();
      if (!file) { showMsg('Please add a screenshot, JPEG, or PDF of your cart or receipt.', false); return; }
      if (emailEl && emailEl.required && !email) { showMsg('Please enter your email so we can send your estimate.', false); return; }
      submit.disabled = true; var lbl = submit.dataset.label || submit.textContent; submit.dataset.label = lbl; submit.textContent = 'Uploading…';
      readFile(file).then(function (img) {
        if (img && img.tooBig) { showMsg('That file is over 8MB, please upload a smaller screenshot or PDF.', false); return null; }
        return fetch('/apps/lmp/quote-request', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kind: 'cart-upload', email: email, filename: img && img.name, fileType: img && img.type, upload: img && img.dataUrl }),
        }).then(function () {
          showMsg('Thanks! We received your cart, our team will size it and email your estimate shortly.', true);
          form.reset(); if (nameEl) nameEl.hidden = true; file = null;
        }).catch(function () {
          showMsg('Could not upload right now, please email it to hello@lmpship.com and we will estimate it.', false);
        });
      }).then(function () { submit.disabled = false; submit.textContent = submit.dataset.label; });
    });
  }

  function init() {
    document.querySelectorAll('[data-lmp-quote-form]').forEach(function (f) {
      initCard(f.closest('.lmp-quote-card') || f.parentNode);
    });
    document.querySelectorAll('[data-lmp-pickup-form]').forEach(initPickup);
    document.querySelectorAll('[data-lmp-upload]').forEach(initUploadCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
